
import { useState, useEffect } from 'react';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);
  
  const slides = [
    {
      title: '马帮瑞贡',
      subtitle: '地道普洱',
      description: '传承三百年马帮精神，奉献一杯地道普洱好茶'
    },
    {
      title: '工艺传承',
      subtitle: '品质至上',
      description: '每一片茶叶都承载着马帮精神的传承与匠心'
    },
    {
      title: '源自云南',
      subtitle: '生态好茶',
      description: '高山云雾出好茶，原生态茶园孕育纯正滋味'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const toggleVideo = () => {
    const video = document.getElementById('hero-video') as HTMLVideoElement;
    if (video) {
      if (isPlaying) {
        video.pause();
      } else {
        video.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleExploreStory = () => {
    const element = document.querySelector('#story');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleTasteNow = () => {
    const element = document.querySelector('#products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0">
        <video
          id="hero-video"
          className="w-full h-full object-cover object-center"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="https://public.readdy.ai/ai/video_res/f554b489-a494-43e9-a7c6-69a182baac3f.mp4" type="video/mp4" />
          {/* 备用图片，如果视频加载失败 */}
          <img
            src="https://public.readdy.ai/ai/img_res/43775292ad759ea2a167316850c28e3f.jpg"
            alt="茶马古道马帮"
            className="w-full h-full object-cover object-center"
          />
        </video>
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Video Controls */}
      <button
        onClick={toggleVideo}
        className="absolute top-6 right-6 text-white hover:text-accent transition-colors duration-300 z-20 cursor-pointer bg-black/20 hover:bg-black/40 rounded-full p-3"
      >
        <i className={`ri-${isPlaying ? 'pause' : 'play'}-line text-xl`}></i>
      </button>

      {/* Content - Adjusted for extended logo area */}
      <div className="relative z-10 h-full flex items-center pt-20">
        <div className="w-full px-6 lg:px-16">
          <div className="max-w-2xl">
            <div className="mb-6">
              <h1 className="text-4xl lg:text-5xl font-bold text-white font-serif mb-4 leading-tight">
                {slides[currentSlide].title}
              </h1>
              <p className="text-xl lg:text-3xl text-accent font-serif mb-6">
                {slides[currentSlide].subtitle}
              </p>
              <p className="text-lg lg:text-xl text-gray-200 leading-relaxed max-w-xl">
                {slides[currentSlide].description}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              <button 
                onClick={handleExploreStory}
                className="bg-secondary hover:bg-secondary/90 text-white px-8 py-4 rounded-full text-base font-medium transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
              >
                探索品牌故事
              </button>
              <button 
                onClick={handleTasteNow}
                className="border-2 border-white text-white hover:bg-white hover:text-primary px-8 py-4 rounded-full text-base font-medium transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                立即品鉴
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide ? 'bg-accent scale-125 shadow-lg' : 'bg-white/50 hover:bg-white/75'
            }`}
          />
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)}
        className="absolute left-6 top-1/2 transform -translate-y-1/2 text-white hover:text-accent transition-colors duration-300 z-20 cursor-pointer bg-black/20 hover:bg-black/40 rounded-full p-3"
      >
        <i className="ri-arrow-left-line text-2xl"></i>
      </button>
      <button
        onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)}
        className="absolute right-6 top-1/2 transform -translate-y-1/2 text-white hover:text-accent transition-colors duration-300 z-20 cursor-pointer bg-black/20 hover:bg-black/40 rounded-full p-3"
      >
        <i className="ri-arrow-right-line text-2xl"></i>
      </button>
    </section>
  );
};

export default Hero;
